import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/NEWS') => `${reducer}/${actionType}`;

export const newsFetchById = (id) => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const title = res.info.TITLE || '';
			const date = res.info.CREATIONDATE || '';
			const content = res.info.CONTENT || '';
			const image = res.info.IMAGE || '';

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.news,
					title,
					date,
					content,
					image,
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.news,
					_status: status,
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.news,
					title: '',
					date: '',
					content: '',
					image: '',
				},
			});
		};

		api.$news_fetchById({ onOK, onStatus, onFail }, { id: Number(id) });
	};
};
